module.exports = __webpack_public_path__ + "media/images/athletes/102-66d31cf8b5dee96cfc8c1f6b1cd0be3a.png";